import {useEffect, useRef, useState} from "react";
import Helpers from "../../helpers/Helpers";
import c from "./ShortNewsContent.module.scss"
import ContentRibbon from "./ContentRibbon";
import helpers from "../../helpers/Helpers";

export default function ShortNewsContentPart({}){
	let [loadingStarted, setLoadingStarted] = useState(false);
	const [shortNews, setShortNews] = useState();

	const swiperRef = useRef(null);
	const [slidesPerViewState, setSlidesPerViewState] = useState(window.innerWidth<768&&'1'||'auto');
	let height = window.innerWidth<768&&'100%'||'130px';
	let slideMaxWidth = window.innerWidth<768&&'100%'||'fit-content';

	useEffect(() => {
		if (!shortNews && !loadingStarted){
			loadingStarted=true;
			setLoadingStarted(true);
			getShortNews();
		}
	}, []);

	const getShortNews = async () => {try{
		let items = await Helpers.searchPaginated('shortNews', null, null, {limit: 10});
		if (items.mainObj?.length>0){
			setShortNews(items.mainObj);
		}
	}catch (e) {
		if (e) console.error(e);
	}}

	function SinglePart({s, i}) {
		return <div className={c.singlePart} style={{background:(i%2===0)?'#14384e':''}} key={shortNews.id}>
			<div className={c.part1}>
				{s.image && <img src={Helpers.getImageSrcFromResource('shortNews', s._id, s.image)}/>}
				<div dangerouslySetInnerHTML={{__html: s.name}}></div>
			</div>
			<div className={c.time}>{helpers.calculateHowLongAgoString(s.date)}</div>
		</div>
	}


	return (
		<div className={[c.root, 'contentBlock'].join(' ')}>
			<ContentRibbon ribbonText={'Raske nyheter'}/>
			<div className={c.controls}>
				<button className={c.controlsLeft} onClick={()=>{
					if (swiperRef.current){
						swiperRef.current.swiper.slidePrev();
					}
				}}>{'<'}</button>
				<button className={c.controlsRight} onClick={()=>{
					if (swiperRef.current){
						swiperRef.current.swiper.slideNext();
					}
				}}>{'>'}</button>
			</div>
			<div className={c.inner}  style={{height:height}}>
				<swiper-container className={c.swiperContainer}
								  navigation="false" ref={swiperRef} style={{width: '100%',height: '100%',overflow:'hidden'}}
								  slides-per-view={slidesPerViewState}
								  space-between="1"
								  grab-cursor="true"
				>
					{shortNews?.length&&shortNews.map((s,i) => {
						return(
							<swiper-slide key={i} style={{maxWidth:slideMaxWidth, width:'clamp(600px, 50px, 100%)', height: '100%'}}>
								<SinglePart s={s} i={i}/>
							</swiper-slide>)
					})}
				</swiper-container>
			</div>
		</div>
	)
}